import React from 'react';

import { Button } from '@waglabs/button-next';
import { Grid } from '@waglabs/grid';

import { DataTestIds } from '../../constants/data-testids';
import { AppleLoginButtonIcon } from '../../icons/AppleLoginButtonIcon';

export type AppleLoginButtonProps = {
  handleAppleLoginButtonClick: () => void;
}

export const AppleLoginButton = ({
  handleAppleLoginButtonClick,
}: AppleLoginButtonProps) => (
  <Grid>
    <Button
      // Stops blue border from appearing on button
      data-testid={DataTestIds.Login.loginForm.AppleLoginButton}
      outline="none !important"
      width="100%"
      onClick={handleAppleLoginButtonClick}
    >
      <AppleLoginButtonIcon
        fontSize="36px"
        data-color="black"
        data-border="true"
        data-type="sign in"
      />

    </Button>
  </Grid>
);
